import ajax from '@/resources/myApi';
import vm from '@/main';

export const service = {
  getFiles,
  saveFile,
  getFileContentType
};

async function getFiles(
  companyId,
  pageNumber,
  pageSize,
  sortBy,
  sortOrder,
  filters
) {

  try {

    const params = {
      companyId,
      pageNumber,
      pageSize,
      sortOrder,
      sortBy,
      filters
    };

    const { data } = await ajax.get(`api/companyfile/forcompany`, {
      name: 'company documents',
      params
    });

    return data;
  } catch (error) {
    return [];
  }
}

async function saveFile(fileObj) {
  try {
    const { data } = await ajax.post('api/companyFile/UploadFiles', {
      name: 'company file save',
      body: fileObj
    });

    vm.$snotify.success('Company File has been added', 'Company File');

    return data;
  } catch (error) {
    console.log(error.message);
    throw error;
  }
}

async function getFileContentType() {
  try {
    const { data } = await ajax.get(`api/CompanyFileCategoryLookupView`, {
      name: 'file content type'
    });
    return data;
  } catch { }
}

export default service;